/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';

/**
 * Global configuration
 */
@Injectable({
  providedIn: 'root',
})
export class ConsultationApiConfiguration {
  rootUrl: string = '';
}

/**
 * Parameters for `ConsultationModule.forRoot()`
 */
export interface ConsultationApiConfigurationParams {
  rootUrl?: string;
}
